export const RESET_STORE = 'RESET_STORE';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN';
export const UPDATE_GUEST_TOKEN = 'UPDATE_GUEST_TOKEN';
export const UPDATE_LOGIN_STATUSS = 'UPDATE_LOGIN_STATUSS';
export const UPDATE_FAMILY_DETAILS = 'UPDATE_FAMILY_DETAILS';
export const UPDATE_WA_OPTIN_STATE = 'UPDATE_WA_OPTIN_STATE'
export const UPDATE_WALLET_DATA = 'UPDATE_WALLET_DATA';
export const UPDATE_SUBSCRIPTION_DATA = 'UPDATE_SUBSCRIPTION_DATA';
export const UPDATE_REVIEWS = 'UPDATE_REVIEWS';
export const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILE_STATUS';
export const UPDATE_AAYU_PLANS = 'UPDATE_AAYU_PLANS';
export const UPDATE_AAYU_ALL_PLANS = 'UPDATE_AAYU_ALL_PLANS';
export const UPDATE_PREMIUM_AAYU_PLAN = 'UPDATE_PREMIUM_AAYU_PLAN';
export const UPDATE_CONSULT_PARAMS = 'UPDATE_CONSULT_PARAMS';
export const UPDATE_CURRENT_QUESTION = 'UPDATE_CURRENT_QUESTION';
export const UPDATE_CURRENT_ANSWER = 'UPDATE_CURRENT_ANSWER';
export const UPDATE_QUESTION_LIST = 'UPDATE_QUESTION_LIST';
export const UPDATE_ANSWER_LIST = 'UPDATE_ANSWER_LIST';
export const UPDATE_IMAGE_LIST = 'UPDATE_IMAGE_LIST';
export const UPDATE_QUESTIONRENDER_STATE = 'UPDATE_QUESTIONRENDER_STATE';
export const UPDATE_ECONSULT_INFO = 'UPDATE_ECONSULT_INFO';
export const UPDATE_SELECTED_AAYU_CARD = 'UPDATE_SELECTED_AAYU_CARD'
export const UPDATE_ADD_UPDATE_SCREEN_DATA = 'UPDATE_ADD_UPDATE_SCREEN_DATA';
export const UPDATE_DASHBOARD_LOADED_STATUS = 'UPDATE_DASHBOARD_LOADED_STATUS';
export const UPDATE_USER_LOGIN_DETAILS = 'UPDATE_USER_LOGIN_DETAILS';
export const UPDATE_CONSULTATIONS_LIST = 'UPDATE_CONSULTATIONS_LIST';
export const UPDATE_ORDER_LIST = 'UPDATE_ORDER_LIST';
export const UPDATE_SELECTED_LOCATION = 'UPDATE_SELECTED_LOCATION';
export const UPDATE_PREVIOUS_SELECTED_LOCATION = 'UPDATE_PREVIOUS_SELECTED_LOCATION';
export const UPDATE_PREVIOUS_SELECTED_MEDICINE_CATEGORY = 'UPDATE_PREVIOUS_SELECTED_MEDICINE_CATEGORY';
export const UPDATE_PREVIOUS_SELECTED_MEDICINE = 'UPDATE_PREVIOUS_SELECTED_MEDICINE';
export const UPDATE_OMS_CART_ITEMS = 'UPDATE_CART_PRODUCTS';
export const UPDATE_OMS_IMAGES_DATA = 'UPDATE_OMS_PRESCRIPTION_IMAGES';
export const UPDATE_OMS_REPEAT_ORDER = 'UPDATE_OMS_REPEAT_ORDER';
export const UPDATE_PHARMACY_DATA = 'UPDATE_PHARMACY_DATA';
export const UPDATE_SELECTED_STORE = 'UPDATE_SELECTED_STORE';
export const UPDATE_MAX_ORDER_GEN_ID = 'UPDATE_MAX_ORDER_GEN_ID';
export const UPDATE_MAX_CONSULT_GEN_ID = 'UPDATE_MAX_CONSULT_GEN_ID';
export const UPDATE_DOWNLOADED_CHAT_IMAGES_LIST = 'UPDATE_DOWNLOADED_CHAT_IMAGES_LIST';
export const UPDATE_ORDER_INSTRUCTIONS_TO_PHARMACY = 'ORDER_INSTRUCTIONS_TO_PHARMACY';
export const UPDATE_USER_VISITED_CHEMIST_SITE = 'UPDATE_USER_VISITED_CHEMIST_SITE'